<template>
  <section class="student-cta">
    <div class="container">
      <div class="cta-content">
        <h2>准备好开始你的能力成长之旅？</h2>
        <p>加入全国数千名学生，通过真实项目打造可验证的能力履历</p>
        <div class="cta-buttons">
          <button class="primary-button" @click="handleSignUp">
            <span>免费注册开始接任务</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M5 12h14M12 5l7 7-7 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="secondary-button" @click="handleViewTasks">
            <span>查看热门任务</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StudentCTA',
  methods: {
    handleSignUp() {
      alert('学生注册 - 将显示注册表单或重定向到注册页')
    },
    handleViewTasks() {
      alert('查看热门任务 - 将显示任务列表')
    }
  }
}
</script>

<style scoped>
.student-cta {
  padding: 4rem 2rem;
  background: linear-gradient(135deg, rgba(0, 102, 255, 0.15), rgba(138, 43, 226, 0.15));
  border-top: 1px solid rgba(0, 217, 255, 0.2);
  border-bottom: 1px solid rgba(0, 217, 255, 0.2);
}

.container {
  max-width: 900px;
  margin: 0 auto;
}

.cta-content {
  text-align: center;
}

.cta-content h2 {
  font-size: 2.2rem;
  font-weight: 800;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #00D9FF, #0066FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.cta-content p {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 2rem;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.primary-button,
.secondary-button {
  padding: 14px 32px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.primary-button {
  background: linear-gradient(135deg, #0066FF, #8A2BE2);
  color: #FFFFFF;
  box-shadow: 0 4px 15px rgba(0, 102, 255, 0.3);
}

.primary-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 102, 255, 0.4);
}

.secondary-button {
  background: transparent;
  border: 2px solid rgba(0, 217, 255, 0.3);
  color: #FFFFFF;
}

.secondary-button:hover {
  background: rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.6);
}

@media (max-width: 768px) {
  .cta-content h2 {
    font-size: 1.6rem;
  }

  .student-cta {
    padding: 2.5rem 1.5rem;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .primary-button,
  .secondary-button {
    width: 100%;
    justify-content: center;
  }
}
</style>
